<template>
    <v-container fluid>
        <v-toolbar flat class="mb-2">
            <v-toolbar-title>Quotes/Orders</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn :disabled="quotes.length === 0" color="success" :to="{name: 'quotesSubmit'}"><v-icon small left >fa-arrow-right</v-icon>Submit</v-btn>
        </v-toolbar>
        <v-data-table
                :headers="headers"
                :loading="loading"
                :items="quotes"
                item-key="part">
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.part }}</td>
                <td class="text-xs-left">{{ props.item.quantity }}</td>
                <td class="text-xs-left">
                    <span v-if="props.item.price">
                        {{ props.item.symbol }} {{ props.item.price | currency }}
                    </span>
                </td>
                <td class="text-xs-left">
                     <span v-if="props.item.price">
                        {{ props.item.symbol }} {{ props.item.price * props.item.quantity | currency }}
                     </span>
                </td>
                <td class="layout px-0">
                    <v-icon title="Edit Quantity" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                    <v-icon title="Delete Part" @click="deleteItem(props.item)">delete</v-icon>
                </td>
            </template>
            <template slot="no-data">
                <v-alert :value="true" color="error" icon="warning">
                    Sorry, no quotes/orders to display here :(
                </v-alert>
            </template>
        </v-data-table>
        <v-btn :disabled="quotes.length === 0" color="error" @click="deleteQuotes()"><v-icon small left>fa-trash-alt</v-icon>Clear Quotes/Orders</v-btn>
        <add-quote-dialog ref="addQuoteDialog"></add-quote-dialog>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Quotes',
  data: function () {
    return {
      selected: [],
      loading: false,
      headers: [
        { text: 'Part', sortable: true, value: 'part' },
        { text: 'Quantity', sortable: true, value: 'quantity' },
        { text: 'Unit Price', sortable: true, value: 'price' },
        { text: 'Total', sortable: true, value: 'total' },
        { text: 'Actions', value: 'name', sortable: false }
      ]
    }
  },
  computed: mapGetters(
    'quote', {
      quotes: 'quotes'
    }
  ),
  methods: {
    ...mapActions(
      'quote', {
        add: 'add',
        delete: 'delete',
        clear: 'clear'
      }
    ),
    editItem (item) {
      this.$refs.addQuoteDialog.show({ isNew: false, item: item, quantity: item.quantity })
    },
    deleteItem (item) {
      confirm('Are you sure you want to delete this quote?') && this.delete({ vue: this, item: item })
    },
    deleteQuotes () {
      confirm('Are you sure you want to delete all quotes?') && this.clear(this)
    }
  }

}
</script>

<style scoped>

</style>
